// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3eBY2","productName":"Table_productName__1bMoc"};